import React, { useEffect } from 'react';
import { LegalSections } from '@ajat/design-system/HelpCenter';
import './LegalPage.css';

/* ══════════════════════════════════════════════════════════════════════════
 * Shared legal content page (Terms & Conditions / Privacy Policy).
 * Reuses the HelpCenter shell (title, typography, container) but renders a
 * single readable prose column — no topic Sidebar.
 *
 * Props:
 *   brand    — 'CLS' | 'ABC' (sets data-brand on <html> like FAQ/Contact)
 *   header   — brand header element, e.g. <Header showTopBar={false} />
 *   footer   — brand footer element, e.g. <Footer />
 *   title    — page h1
 *   sections — [{ title?, blocks: [{ type: 'p'|'ul'|'lines'|'h4', text?, items? }] }]
 * ══════════════════════════════════════════════════════════════════════════ */

/** The section renderer lives in the package (`@ajat/design-system/HelpCenter`) since 2026-11-04 — every
    checkout's privacy SidePanel (webshop brands, OVER/LL) renders it too; re-exported here for the brand pages. */
export { LegalSections };

const LegalPage = ({ brand = 'CLS', header, footer, title, sections = [] }) => {
  useEffect(() => {
    const prev = document.documentElement.getAttribute('data-brand');
    document.documentElement.setAttribute('data-brand', brand);
    return () => {
      if (prev) document.documentElement.setAttribute('data-brand', prev);
      else document.documentElement.removeAttribute('data-brand');
    };
  }, [brand]);

  return (
    <div className="helpcenter">
      {header}
      <main className="helpcenter__main">
        <div className="helpcenter__container">
          <div className="helpcenter__list-col legal-page__col">
            <h1 className="helpcenter__title typo-h1">{title}</h1>

            <LegalSections sections={sections} />
          </div>
        </div>
      </main>
      {footer}
    </div>
  );
};

export default LegalPage;
